/*
 * Norfie theme JS — announcement rotator, mobile drawer, cart, product page.
 */
(function () {
  // Announcement rotator
  const ann = document.querySelector('[data-component="announcement-bar"] .announcement-bar__track');
  if (ann) {
    const msgs = ann.querySelectorAll('.announcement-bar__message');
    if (msgs.length > 1) {
      msgs.forEach((m, i) => (m.style.display = i === 0 ? 'inline' : 'none'));
      let idx = 0;
      setInterval(() => {
        msgs[idx].style.display = 'none';
        idx = (idx + 1) % msgs.length;
        msgs[idx].style.display = 'inline';
      }, 3500);
    }
  }

  // Mobile drawer
  const drawer = document.querySelector('[data-mobile-drawer]');
  const setDrawer = (open) => drawer && drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
  document.querySelectorAll('[data-mobile-menu-open]').forEach((b) => b.addEventListener('click', () => setDrawer(true)));
  document.querySelectorAll('[data-mobile-menu-close]').forEach((b) => b.addEventListener('click', () => setDrawer(false)));

  // ===================== Cart drawer =====================
  const FREE_SHIPPING_THRESHOLD = (window.NORFIE && window.NORFIE.freeShippingCents) || 10000; // cents
  const SHIPPING_FEE = 599; // cents
  const drawerEl = document.querySelector('[data-cart-drawer]');
  const fmtMoney = (cents) => '$' + (cents / 100).toFixed(2);

  const renderCartDrawer = (cart) => {
    if (!drawerEl) return;
    const body = drawerEl.querySelector('[data-cart-body]');
    const footer = drawerEl.querySelector('[data-cart-footer]');
    const progress = drawerEl.querySelector('[data-cart-progress]');
    const subtotalEl = drawerEl.querySelector('[data-cart-subtotal]');
    const shippingEl = drawerEl.querySelector('[data-cart-shipping]');
    const checkoutBtn = drawerEl.querySelector('[data-cart-checkout]');

    document.querySelectorAll('[data-cart-count]').forEach((el) => (el.textContent = cart.item_count));

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<div class="cart-drawer__empty-icon" aria-hidden="true">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>' +
          '</div>' +
          '<p class="cart-drawer__empty-title">Your cart is empty</p>' +
          '<p class="cart-drawer__empty-body">Start shopping for your best friend — free shipping on orders over ' + ((window.NORFIE && window.NORFIE.freeShippingLabel) || '$100') + '.</p>' +
          '<button type="button" class="btn btn-primary" data-cart-close>Start shopping</button>' +
        '</div>';
      footer.hidden = true;
      progress.hidden = true;
      return;
    }

    // Free shipping progress bar
    progress.hidden = false;
    const fill = drawerEl.querySelector('[data-cart-progress-fill]');
    const msg = drawerEl.querySelector('[data-cart-progress-msg]');
    const pct = Math.min(100, (cart.total_price / FREE_SHIPPING_THRESHOLD) * 100);
    fill.style.width = pct + '%';
    if (cart.total_price >= FREE_SHIPPING_THRESHOLD) {
      msg.innerHTML = 'You unlocked <strong>FREE shipping</strong>';
      fill.classList.add('is-complete');
    } else {
      const left = FREE_SHIPPING_THRESHOLD - cart.total_price;
      msg.innerHTML = "You're <strong>" + fmtMoney(left) + '</strong> away from free shipping';
      fill.classList.remove('is-complete');
    }

    // Render items
    body.innerHTML = cart.items.map((it) => (
      '<div class="cart-drawer__item" data-cart-item="' + it.key + '">' +
        '<a href="' + it.url + '" class="cart-drawer__item-img">' +
          (it.image ? '<img src="' + it.image + '" alt="" loading="lazy" width="80" height="80">' : '') +
        '</a>' +
        '<div class="cart-drawer__item-body">' +
          (it.vendor ? '<p class="cart-drawer__item-vendor">' + it.vendor + '</p>' : '') +
          '<a href="' + it.url + '" class="cart-drawer__item-title">' + it.product_title + '</a>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<p class="cart-drawer__item-variant">' + it.variant_title + '</p>' : '') +
          '<div class="cart-drawer__item-row">' +
            '<div class="cart-drawer__qty">' +
              '<button type="button" data-qty-change="' + it.key + '" data-qty-delta="-1" aria-label="Decrease">−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-qty-change="' + it.key + '" data-qty-delta="1" aria-label="Increase">+</button>' +
            '</div>' +
            '<span class="cart-drawer__item-price">' + fmtMoney(it.final_line_price) + '</span>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="cart-drawer__item-remove" data-cart-remove="' + it.key + '" aria-label="Remove">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>' +
        '</button>' +
      '</div>'
    )).join('');

    footer.hidden = false;
    subtotalEl.textContent = fmtMoney(cart.total_price);
    const isFree = cart.total_price >= FREE_SHIPPING_THRESHOLD;
    shippingEl.textContent = isFree ? 'FREE' : fmtMoney(SHIPPING_FEE);
    shippingEl.classList.toggle('is-free', isFree);
    const total = cart.total_price + (isFree ? 0 : SHIPPING_FEE);
    checkoutBtn.querySelector('span').textContent = 'Checkout · ' + fmtMoney(total);
  };

  const updateCart = async () => {
    try {
      const cart = await (await fetch('/cart.js')).json();
      renderCartDrawer(cart);
      return cart;
    } catch (e) { console.error(e); }
  };

  const openCart = async () => {
    if (!drawerEl) { window.location = '/cart'; return; }
    drawerEl.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => drawerEl.classList.add('is-open'));
    await updateCart();
  };
  const closeCart = () => {
    if (!drawerEl) return;
    drawerEl.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(() => { drawerEl.hidden = true; }, 320);
  };

  document.addEventListener('click', async (e) => {
    const openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); openCart(); return; }
    const closeBtn = e.target.closest('[data-cart-close]');
    if (closeBtn) { e.preventDefault(); closeCart(); return; }
    const removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      const key = removeBtn.dataset.cartRemove;
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) });
      await updateCart();
      return;
    }
    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      const key = qtyBtn.dataset.qtyChange;
      const delta = parseInt(qtyBtn.dataset.qtyDelta, 10);
      const item = drawerEl.querySelector('[data-cart-item="' + CSS.escape(key) + '"]');
      const current = item ? parseInt(item.querySelector('.cart-drawer__qty span').textContent, 10) : 1;
      const next = Math.max(0, current + delta);
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: next }) });
      await updateCart();
      return;
    }
  });

  // Close on ESC
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

  // ----- Toast + cart icon bump -----
  let toastEl = null;
  const showToast = (msg) => {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'norfie-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>' +
        '<span class="norfie-toast__msg"></span>';
      document.body.appendChild(toastEl);
    }
    toastEl.querySelector('.norfie-toast__msg').textContent = msg;
    toastEl.classList.remove('is-visible');
    // restart animation
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), 1800);
  };
  const bumpCart = () => {
    document.querySelectorAll('.site-header__cart, [data-cart-open]').forEach((el) => {
      el.classList.remove('is-bumping');
      void el.offsetWidth;
      el.classList.add('is-bumping');
      setTimeout(() => el.classList.remove('is-bumping'), 600);
    });
  };

  // AJAX add-to-cart for any form with data-ajax-cart OR product form on PDP
  const handleAjaxAdd = async (form) => {
    const btn = form.querySelector('button[type=submit]');
    const original = btn ? btn.innerHTML : null;
    if (btn) btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form),
      });
      if (!res.ok) throw new Error('add failed');
      showToast('Added to cart');
      bumpCart();
      await openCart();
    } catch (err) {
      console.error(err);
      if (btn) { btn.innerHTML = '⚠ Try again'; setTimeout(() => { btn.innerHTML = original; }, 1500); }
    } finally {
      if (btn) { btn.disabled = false; if (original) btn.innerHTML = original; }
    }
  };

  document.querySelectorAll('[data-ajax-cart]').forEach((form) => {
    form.addEventListener('submit', (e) => { e.preventDefault(); handleAjaxAdd(form); });
  });
  // Hook product form on PDP too
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', (e) => { e.preventDefault(); handleAjaxAdd(form); });
  });

  // Sort select on collection
  const sortSel = document.querySelector('[data-sort-by]');
  if (sortSel) sortSel.addEventListener('change', (e) => {
    const url = new URL(window.location);
    url.searchParams.set('sort_by', e.target.value);
    window.location = url.toString();
  });

  // Collection filters — auto-submit on change (checkboxes, radios).
  // <form method="get"> rebuilds URL from all named inputs, so unchecked
  // checkboxes drop out automatically. Shopify reads the URL params.
  const filtersForm = document.querySelector('[data-filters-form]');
  if (filtersForm) {
    filtersForm.addEventListener('change', (e) => {
      if (e.target.matches('input[type=checkbox], input[type=radio]')) {
        filtersForm.requestSubmit();
      }
    });

    // Show more / Show less on long filter value lists
    filtersForm.querySelectorAll('[data-filter-show-more]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const list = btn.previousElementSibling;
        if (!list || !list.matches('[data-filter-values]')) return;
        const expanded = list.classList.toggle('is-expanded');
        btn.textContent = expanded ? btn.dataset.labelLess : btn.dataset.labelMore;
      });
    });

    // Collapsible filter groups (click heading to toggle)
    filtersForm.querySelectorAll('[data-filter-collapse]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const group = btn.closest('[data-filter-group]');
        if (!group) return;
        const isCollapsed = group.classList.toggle('is-collapsed');
        btn.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
      });
    });
  }

  // ----- Product page -----
  const productForm = document.querySelector('[data-product-form]');
  if (productForm) initProduct(productForm);

  function initProduct(form) {
    const productData = JSON.parse(document.querySelector('[data-product-json]')?.textContent || 'null');

    // Gallery
    const main = document.querySelector('[data-gallery-main]');
    const slideCount = main ? main.children.length : 0;
    let activeIndex = 0;
    const setActiveThumb = (i) => {
      activeIndex = i;
      document.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.classList.toggle('is-active', parseInt(t.dataset.galleryThumb, 10) === i));
      document.querySelectorAll('[data-gallery-thumb-mobile]').forEach((t) => t.classList.toggle('is-active', parseInt(t.dataset.galleryThumbMobile, 10) === i));
      document.querySelectorAll('[data-dot]').forEach((d) => d.classList.toggle('is-active', parseInt(d.dataset.dot, 10) === i));
      // Update prev/next disabled state
      const prev = document.querySelector('[data-gallery-prev]');
      const next = document.querySelector('[data-gallery-next]');
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i >= slideCount - 1;
    };
    const goTo = (i) => {
      if (main && main.children[i]) {
        main.children[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        setActiveThumb(i);
      }
    };
    document.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => goTo(parseInt(thumb.dataset.galleryThumb, 10)));
    });
    document.querySelectorAll('[data-gallery-thumb-mobile]').forEach((thumb) => {
      thumb.addEventListener('click', () => goTo(parseInt(thumb.dataset.galleryThumbMobile, 10)));
    });
    document.querySelector('[data-gallery-prev]')?.addEventListener('click', () => goTo(Math.max(0, activeIndex - 1)));
    document.querySelector('[data-gallery-next]')?.addEventListener('click', () => goTo(Math.min(slideCount - 1, activeIndex + 1)));
    if (main) {
      main.addEventListener('scroll', () => {
        const i = Math.round(main.scrollLeft / main.clientWidth);
        if (i !== activeIndex) setActiveThumb(i);
      }, { passive: true });
      // Init prev/next state
      setActiveThumb(0);
    }

    // Variant picker
    const picker = document.querySelector('[data-variant-picker]');
    if (picker && productData) {
      const onChange = () => {
        const selected = [];
        picker.querySelectorAll('fieldset').forEach((fs) => {
          const idx = parseInt(fs.dataset.optionIndex, 10);
          const r = fs.querySelector('input[type=radio]:checked');
          selected[idx] = r ? r.value : null;
          fs.querySelector('[data-option-selected]').textContent = r ? r.value : '';
          fs.querySelectorAll('.variant-picker__chip').forEach((c) =>
            c.classList.toggle('is-active', c.querySelector('input').checked)
          );
        });
        const variant = productData.variants.find((v) =>
          v.options.every((opt, i) => opt === selected[i])
        );
        if (variant) {
          form.querySelector('input[name="id"]').value = variant.id;
          const priceEl = form.querySelector('[data-price] .product__price-current');
          if (priceEl) priceEl.textContent = new Intl.NumberFormat('en-US', { style: 'currency', currency: productData.currency || 'USD' }).format(variant.price / 100);
          const skuEl = document.querySelector('[data-product-sku] span');
          if (skuEl && variant.sku) skuEl.textContent = variant.sku;
          const url = picker.dataset.url + '?variant=' + variant.id;
          window.history.replaceState({}, '', url);
        }
      };
      picker.querySelectorAll('input[type=radio]').forEach((r) => r.addEventListener('change', onChange));
    }

    // Purchase mode toggle
    document.querySelectorAll('.purchase-mode__row').forEach((row) => {
      row.addEventListener('click', () => {
        document.querySelectorAll('.purchase-mode__row').forEach((r) => r.classList.remove('purchase-mode__row--active'));
        row.classList.add('purchase-mode__row--active');
        row.querySelector('input[type=radio]').checked = true;
      });
    });

    // Qty stepper
    const qtyInput = form.querySelector('[data-qty-value]');
    form.querySelector('[data-qty-dec]')?.addEventListener('click', () => { qtyInput.value = Math.max(1, +qtyInput.value - 1); });
    form.querySelector('[data-qty-inc]')?.addEventListener('click', () => { qtyInput.value = Math.min(99, +qtyInput.value + 1); });

    // AJAX ATC handled by global [data-product-form] binding above (handleAjaxAdd).
    // Avoid double-binding here to prevent items being added twice.

    // Sticky ATC visibility
    const sticky = document.querySelector('[data-sticky-atc]');
    if (sticky) {
      const onScroll = () => sticky.setAttribute('aria-hidden', window.scrollY > 520 ? 'false' : 'true');
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      sticky.querySelector('[data-sticky-atc-btn]')?.addEventListener('click', () => form.requestSubmit());
    }

    // Countdown
    const cd = document.querySelector('[data-countdown]');
    if (cd) {
      const tick = () => {
        const now = new Date();
        const cut = new Date(); cut.setHours(14, 0, 0, 0);
        if (now > cut) cut.setDate(cut.getDate() + 1);
        const diff = cut - now;
        const h = Math.floor(diff / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        cd.textContent = `${h}h ${m}m`;
      };
      tick();
      setInterval(tick, 60000);
    }
  }
})();

// ----- Predictive search (Shopify /search/suggest.json) -----
(function () {
  const wrap = document.querySelector('[data-predictive-search]');
  if (!wrap) return;
  const input = wrap.querySelector('[data-predictive-input]');
  const panel = wrap.querySelector('[data-predictive-panel]');
  let timer;

  const render = (data) => {
    const products = data?.resources?.results?.products || [];
    if (products.length === 0) {
      panel.innerHTML = '<p style="padding:1rem;text-align:center;color:#6b7280;font-size:0.85rem">No matches.</p>';
      panel.hidden = false;
      return;
    }
    panel.innerHTML = '<div class="predictive-search__section"><h4>Products</h4>' +
      products.map((p) => `
        <a href="${p.url}" class="predictive-search__product">
          <img src="${p.featured_image?.url || p.image || ''}" alt="" loading="lazy">
          <div style="flex:1;min-width:0">
            <div style="font-size:10px;text-transform:uppercase;color:#6b7280;font-weight:700;letter-spacing:0.05em">${p.vendor || ''}</div>
            <div class="predictive-search__product-title">${p.title}</div>
          </div>
          <div class="predictive-search__product-price">${p.price || ''}</div>
        </a>
      `).join('') + '</div>';
    panel.hidden = false;
  };

  input.addEventListener('input', () => {
    clearTimeout(timer);
    const q = input.value.trim();
    if (q.length < 2) { panel.hidden = true; return; }
    timer = setTimeout(async () => {
      try {
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
        const data = await res.json();
        render(data);
      } catch (err) { console.error(err); }
    }, 180);
  });

  document.addEventListener('click', (e) => {
    if (!wrap.contains(e.target)) panel.hidden = true;
  });
})();

// ----- Exit-intent popup -----
(function () {
  const popup = document.querySelector('[data-exit-intent]');
  if (!popup) return;
  const KEY = 'norfie_exit_intent_shown_v1';
  if (sessionStorage.getItem(KEY)) return;

  let triggered = false;
  const trigger = () => {
    if (triggered) return;
    triggered = true;
    sessionStorage.setItem(KEY, '1');
    popup.setAttribute('aria-hidden', 'false');
  };

  document.addEventListener('mouseout', (e) => {
    if (e.clientY <= 0 && e.relatedTarget == null) trigger();
  });

  setTimeout(() => {
    if (window.matchMedia('(max-width: 767px)').matches) trigger();
  }, 25000);

  popup.querySelectorAll('[data-exit-intent-close]').forEach((el) =>
    el.addEventListener('click', () => popup.setAttribute('aria-hidden', 'true'))
  );
})();

// ----- Free-shipping bar (live update via /cart.js) -----
(function () {
  const bar = document.querySelector('[data-fs-bar]');
  if (!bar) return;
  const fill = bar.querySelector('[data-fs-fill]');
  const remaining = bar.querySelector('[data-fs-remaining]');
  const threshold = parseInt(bar.dataset.threshold || (window.NORFIE && window.NORFIE.freeShippingCents) || '10000', 10);

  const update = async () => {
    try {
      const cart = await (await fetch('/cart.js')).json();
      const pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
      if (fill) fill.style.width = `${pct}%`;
      const left = Math.max(0, threshold - cart.total_price);
      if (cart.total_price >= threshold) {
        bar.classList.add('fs-bar--unlocked');
      } else {
        bar.classList.remove('fs-bar--unlocked');
        if (remaining) remaining.textContent = '$' + (left / 100).toFixed(2);
      }
    } catch (e) {}
  };
  // Refresh on cart events
  document.addEventListener('cart:updated', update);
})();


// ----- Cart page (AJAX qty +/− and remove) -----
(function () {
  const page = document.querySelector('[data-cart-page]');
  if (!page) return;

  const FREE_SHIPPING_THRESHOLD = (window.NORFIE && window.NORFIE.freeShippingCents) || 10000;
  const SHIPPING_FEE = 599;
  const fmtMoney = (cents) => '$' + (cents / 100).toFixed(2);

  const linesEl = page.querySelector('[data-cart-page-lines]');
  const summaryEl = page.querySelector('[data-cart-page-summary]');
  const fsBar = document.querySelector('[data-fs-bar]');

  const renderTotals = (cart) => {
    const subtotalEl = page.querySelector('[data-cart-page-subtotal]');
    const totalEl = page.querySelector('[data-cart-page-total]');
    const countEl = page.querySelector('[data-cart-page-count]');
    if (subtotalEl) subtotalEl.textContent = fmtMoney(cart.total_price);
    if (totalEl) totalEl.textContent = fmtMoney(cart.total_price);
    if (countEl) countEl.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items');
    document.querySelectorAll('[data-cart-count]').forEach((el) => (el.textContent = cart.item_count));
    // Notify free-shipping bar to refresh
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  };

  const showEmpty = () => {
    const tpl = page.querySelector('[data-cart-page-empty-template]');
    const main = page.querySelector('.cart-page__layout');
    if (tpl && main) {
      const clone = tpl.content.cloneNode(true);
      main.replaceWith(clone);
      if (fsBar) fsBar.style.display = 'none';
    }
  };

  const updateLine = async (key, quantity) => {
    page.classList.add('is-loading');
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      if (!res.ok) throw new Error('cart change failed');
      const cart = await res.json();
      const line = cart.items.find((it) => it.key === key);
      const lineEl = linesEl ? linesEl.querySelector('[data-cart-page-line="' + CSS.escape(key) + '"]') : null;

      if (!line && lineEl) {
        // Removed — animate out then drop
        lineEl.classList.add('is-removing');
        setTimeout(() => lineEl.remove(), 220);
      } else if (line && lineEl) {
        const qtyValEl = lineEl.querySelector('[data-line-qty-value="' + CSS.escape(key) + '"]');
        const priceEl = lineEl.querySelector('[data-line-price="' + CSS.escape(key) + '"]');
        const unitEl = lineEl.querySelector('[data-line-unit-price="' + CSS.escape(key) + '"]');
        if (qtyValEl) qtyValEl.textContent = line.quantity;
        if (priceEl) priceEl.textContent = fmtMoney(line.final_line_price);
        if (unitEl) unitEl.textContent = fmtMoney(line.final_price);
      }

      renderTotals(cart);

      if (cart.item_count === 0) {
        setTimeout(showEmpty, 230);
      }
    } catch (err) {
      console.error(err);
    } finally {
      page.classList.remove('is-loading');
    }
  };

  page.addEventListener('click', (e) => {
    const qtyBtn = e.target.closest('[data-line-qty]');
    if (qtyBtn) {
      e.preventDefault();
      const key = qtyBtn.dataset.lineQty;
      const delta = parseInt(qtyBtn.dataset.lineDelta, 10);
      const valEl = page.querySelector('[data-line-qty-value="' + CSS.escape(key) + '"]');
      const current = valEl ? parseInt(valEl.textContent, 10) || 1 : 1;
      const next = Math.max(0, current + delta);
      updateLine(key, next);
      return;
    }
    const removeBtn = e.target.closest('[data-line-remove]');
    if (removeBtn) {
      e.preventDefault();
      updateLine(removeBtn.dataset.lineRemove, 0);
    }
  });

  // Initial total render (so the "Total" row gets populated on first paint)
  fetch('/cart.js').then((r) => r.json()).then(renderTotals).catch(() => {});
})();

// ----- Wishlist (heart toggle, persisted in localStorage) -----
(function () {
  const KEY = 'norfie_wishlist_v1';
  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch (e) { return []; }
  };
  const write = (arr) => {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
  };

  const sync = () => {
    const list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const handle = btn.dataset.productHandle;
      const on = list.includes(handle);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => (el.textContent = list.length));
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.dataset.productHandle;
    if (!handle) return;
    const list = read();
    const idx = list.indexOf(handle);
    if (idx >= 0) list.splice(idx, 1); else list.push(handle);
    write(list);
    sync();
    // Heart bump animation
    btn.classList.remove('is-bumping');
    void btn.offsetWidth;
    btn.classList.add('is-bumping');
    setTimeout(() => btn.classList.remove('is-bumping'), 500);
  });

  sync();
})();

// ----- Native share + clipboard fallback -----
(function () {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-product-share]');
    if (!btn) return;
    e.preventDefault();
    const url = window.location.href;
    const title = btn.dataset.productTitle || document.title;
    const text = 'Check out ' + title + ' on Norfie';
    try {
      if (navigator.share) {
        await navigator.share({ title, text, url });
        return;
      }
      await navigator.clipboard.writeText(url);
      // Lightweight inline tooltip
      btn.classList.add('is-copied');
      btn.setAttribute('data-tooltip', 'Link copied!');
      setTimeout(() => {
        btn.classList.remove('is-copied');
        btn.removeAttribute('data-tooltip');
      }, 1600);
    } catch (err) {
      console.error('Share failed:', err);
    }
  });
})();

